import { noop } from 'lodash'
import { show as showEndTenancyModal } from '@/features/EndTenancy/end-tenancy-modal'
import { show as showPaymentDetailsModal } from '@/features/Payments/payment-details-modal'
import { toast } from '@/components/toast-notifications'
import { colors } from '@/styles'
import config from '@/config'
import AgreementCompletedIcon from '../chat-icons/AgreementCompleted.svg'
import ApplicationNotSelectedIcon from '../chat-icons/ApplicationNotSelected.svg'
import ApplicationReceivedIcon from '../chat-icons/ApplicationReceived.svg'
import ApplicationWithdrawnIcon from '../chat-icons/ApplicationWithdrawn.svg'
import CancelledIcon from '../chat-icons/Cancelled.svg'
import ContractExpiredIcon from '../chat-icons/ContractExpired.svg'
import ContractReceivedIcon from '../chat-icons/ContractReceived.svg'
import ContractRenewalIcon from '../chat-icons/ContractRenewalReceived.svg'
import ContractSignedLandlordIcon from '../chat-icons/ContractSignedLandlord.svg'
import DocumentSentIcon from '../chat-icons/DocumentSent.svg'
import EndTenancyConfirmedIcon from '../chat-icons/EndTenancyConfirmed.svg'
import EndTenancyNoticeIcon from '../chat-icons/EndTenancyNotice.svg'
import EndTenancyRequestReceivedIcon from '../chat-icons/EndTenancyRequestReceived.svg'
import EndTenancyRequestRefusedIcon from '../chat-icons/EndTenancyRequestRefused.svg'
import EndTenancyRequestSentIcon from '../chat-icons/EndTenancyRequestSent.svg'
import PaymentRequestReceivedIcon from '../chat-icons/PaymentRequestReceived.svg'
import ProofDocumentApproved from '../chat-icons/ProofDocumentApproved.svg'
import ProofDocumentNotApproved from '../chat-icons/ProofDocumentNotApproved.svg'
import PadDocumentApproved from '../chat-icons/PadDocumentApproved.svg'
import PadDocumentNotApproved from '../chat-icons/PadDocumentNotApproved.svg'
import RentPaymentReceivedIcon from '../chat-icons/RentPaymentReceived.svg'
import RentPaymentSentIcon from '../chat-icons/RentPaymentSent.svg'
import SupportRequestIcon from '../chat-icons/SupportRequest.svg'
import TenantFoundIcon from '../chat-icons/TenantFound.svg'
import PadPaymentFailed from '../chat-icons/PadPaymentFailed.svg'
import CustomContractIcon from '../chat-icons/CustomContract.svg'
import CustomContractVoidedIcon from '../chat-icons/CustomContractVoided.svg'
import CustomContractCompleteIcon from '../chat-icons/CustomAgreementCompleted.svg'
import ListingVerification from '../chat-icons/ListingVerification.svg'
import IdVerification from '../chat-icons/IdVerification.svg'

const { APP_PATH } = config

const metadata = (isThem, event, t, userRole, history) => {
  const isTenant = userRole === 'tenant'
  const verificationLink = isTenant ? `/profile/verify` : `/profile/`
  const displayName = event?.display_name
  const eventInfo = event?.event_info || {}

  const getStatus = (info = {}) => {
    if (info.state_machine === 'voided')
      return {
        title: t('b.chat.view.voided.title', 'Voided'),
        type: 'error'
      }
    if (info.state_machine === 'withdrawn')
      return {
        title: t('b.chat.view.document_withdrawn.title', 'Document Withdrawn'),
        type: 'error'
      }
    if (info.signature_required === true) {
      if (info.state_machine === 'signed')
        return (isTenant && info.user_type === 'tenant') ||
          (!isTenant && info.user_type === 'landlord')
          ? {
              title: t('b.chat.view.signed.title', 'Signed'),
              type: 'success'
            }
          : {
              title: `Signed by ${info.required_signer_user_first_name} ${info.required_signer_user_last_name}`,
              type: 'success'
            }
      else
        return (isTenant && info.user_type === 'tenant') ||
          (!isTenant && info.user_type === 'landlord')
          ? {
              title: t('b.chat.view.your_signature_required.title', 'Your signature required'),
              type: 'warning'
            }
          : {
              title: t('b.chat.view.awaiting_signature.title', 'Awaiting signature'),
              type: 'warning'
            }
    }
    return {
      title: t('b.chat.view.pending_signatures.title', 'Pending signatures'),
      type: 'warning'
    }
  }

  const getRoute = info => {
    if (isThem) return ''

    if (
      info.state_machine !== 'voided' &&
      info.state_machine !== 'signed' &&
      info.state_machine !== 'withdrawn' &&
      info.signature_required === true &&
      ((isTenant && info.user_type === 'tenant') || (!isTenant && info.user_type === 'landlord'))
    ) {
      window.open(
        `${APP_PATH}/custom-contract/sign/${info.contract_id}/${info.support_doc_id}`,
        '_blank',
        'noopener,noreferrer'
      )

      return
    }
    if (info.state_machine === 'voided' || info.state_machine === 'withdrawn') {
      if (isTenant) {
        toast(
          t(
            'l.showings.view.document_no_longer_valid.text',
            'This document is no longer valid. Please contact the landlord for more information'
          ),
          {
            title:
              info.state_machine !== 'voided'
                ? t('l.showings.view.document_voided.title', 'Document Voided')
                : t('l.showings.view.document_withdrawn.title', 'Document Withdrawn'),
            type: 'error'
          }
        )
        return
      } else {
        toast(
          t(
            'l.showings.view.document_no_longer_valid_landlord.text',
            'This document is no longer valid.'
          ),
          {
            title:
              info.state_machine !== 'voided'
                ? t('l.showings.view.document_voided.title', 'Document Voided')
                : t('l.showings.view.document_withdrawn.title', 'Document Withdrawn'),
            type: 'error'
          }
        )
        history.push(`/contract/manager/${info.contract_id}`)
      }
    }

    history.push(`/contract/manager/${info.contract_id}`)
  }
  const data = {
    chat_all_signed_contract: {
      title: t('b.chat.view.contract_fully_signed.title', 'Agreement Completed!'),
      to: `/contract/${eventInfo.contract_id || event?.reference_object_id}`,
      background: colors.green56,
      icon: AgreementCompletedIcon
    },
    chat_appointment_canceled: {
      title: isThem
        ? t('r.chat.view.landlord_showing_cancelled.title', {
            defaultValue: 'Showing Cancelled by {{user}}',
            user: isTenant ? t('common.landlord') : t('common.renter')
          })
        : t('r.chat.view.showing_cancelled.title', 'Showing Cancelled'),
      background: colors.mediumGrey
    },
    chat_appointment_user_subscribed: {
      title: t('b.chat.view.showing_booked.text', 'Showing Booked'),
      background: colors.red64,
      onClick: () => {
        return isTenant ? noop() : history.push(`/listing/${event.listing_id}/showings`)
      }
    },

    chat_appointment_delayed: {
      title: t('b.chat.view.showing_delayed.text', 'Showing Delayed'),
      background: colors.red64
    },
    chat_appointment_user_unsubscribed: {
      title: isThem
        ? t('r.chat.view.landlord_showing_cancelled.title', {
            defaultValue: 'Showing Cancelled by {{user}}',
            user: isTenant ? 'Landlord' : 'Renter'
          })
        : t('r.chat.view.showing_cancelled.title', 'Showing Cancelled'),
      background: colors.mediumGrey
    },
    chat_cancel_application: {
      title: t('b.chat.view.application_withdrawn.title', 'Application Withdrawn'),
      background: colors.regular,
      icon: ApplicationWithdrawnIcon
    },
    chat_cancel_contract: {
      title: t('b.chat.view.contract_cancelled.title', 'Contract Cancelled'),
      background: colors.mediumGrey,
      icon: CancelledIcon
    },
    chat_end_contract_ended: {
      title: t('b.chat.view.contract_expired.text', 'Contract Expired'),
      background: colors.regular,
      icon: ContractExpiredIcon
    },
    chat_end_contract_moving_out: {
      title: t('b.chat.view.end_tenancy_notice.title', 'End Tenancy Notice'),
      background: colors.green56,
      icon: EndTenancyNoticeIcon
    },
    chat_end_contract_renew_refused: {
      title: t('b.chat.view.contract_renewal_refused.text', 'Contract Renewal Request Refused'),
      background: colors.regular,
      icon: EndTenancyRequestRefusedIcon
    },
    chat_end_contract_renew_requested: {
      title: isThem
        ? t('b.chat.view.renewal_request_received.title', 'Contract Renewal Request Received')
        : t('b.chat.view.renewal_request_sent.title', 'Contract Renewal Request Sent'),
      background: colors.red64,
      icon: ContractRenewalIcon
    },
    chat_end_tenancy_request_done: {
      title: t('b.chat.view.end_tenancy_done.title', 'End Tenancy Done'),
      background: colors.green56,
      icon: EndTenancyConfirmedIcon,
      onClick: e =>
        showEndTenancyModal({
          listingId: e?.listing_id,
          endTenancyId: e?.event_info?.id
        })
    },
    chat_end_tenancy_request_cancelled: {
      title: t('b.chat.view.end_tenancy_cancelled.title', 'End Tenancy Request Cancelled'),
      background: colors.mediumGrey,
      icon: CancelledIcon,
      onClick: e =>
        showEndTenancyModal({
          listingId: e?.listing_id,
          endTenancyId: e?.event_info?.id
        })
    },
    chat_end_tenancy_request_confirmed: {
      title: t('b.chat.view.end_tenancy_confirmed.title', 'End Tenancy Request Confirmed'),
      background: colors.green56,
      icon: EndTenancyConfirmedIcon,
      onClick: e =>
        showEndTenancyModal({
          listingId: e?.listing_id,
          endTenancyId: e?.event_info?.id
        })
    },
    chat_end_tenancy_request_created: {
      title: isThem
        ? t('b.chat.view.end_tenancy_received.title', 'End Tenancy Request Received')
        : t('b.chat.view.end_tenancy_sent.title', 'End Tenancy Request Sent'),
      background: colors.green56,
      icon: isThem ? EndTenancyRequestReceivedIcon : EndTenancyRequestSentIcon,
      onClick: e =>
        showEndTenancyModal({
          listingId: e?.listing_id,
          endTenancyId: e?.event_info?.id
        })
    },

    chat_end_tenancy_request_refused: {
      title: t('b.chat.view.end_tenancy_refused .title', 'End Tenancy Request Refused'),
      background: colors.regular,
      icon: EndTenancyRequestRefusedIcon,
      onClick: e =>
        showEndTenancyModal({
          listingId: e?.listing_id,
          endTenancyId: e?.event_info?.id
        })
    },
    chat_end_tenancy_support_requested: {
      title: isThem
        ? t('b.chat.view.tenant_support_requested.title', {
            defaultValue: 'Support Requested by {{user}}',
            user: isTenant ? 'Landlord' : 'Tenant'
          })
        : t('b.chat.view.tenancy_support_requested.title', 'End Tenancy Support Requested'),
      background: colors.mediumGrey,
      icon: SupportRequestIcon,
      onClick: e =>
        showEndTenancyModal({
          listingId: e?.listing_id,
          endTenancyId: e?.event_info?.id
        })
    },
    chat_listing_has_been_rented: {
      title: isThem
        ? t('b.chat.view.application_not_selected.title', 'Application Not Selected!')
        : t('b.chat.view.tenant_found.title', 'Tenant Found'),
      background: isThem ? colors.regular : colors.green56,
      icon: isThem ? ApplicationNotSelectedIcon : TenantFoundIcon
    },
    chat_new_contract: {
      title: isThem
        ? t('l.chat.view.contract_received.title', 'Contract Received')
        : t('r.chat.view.contract_sent.title', 'Contract Sent'),
      to: `/contract/${eventInfo.contract_id || event?.reference_object_id}`,
      background: colors.red64,
      icon: isThem ? ContractReceivedIcon : DocumentSentIcon
    },
    chat_application_invite: {
      title: isThem
        ? t('r.chat.view.application_invitation_received.title', 'Invitation to Apply')
        : t('l.chat.view.application_invitation_sent.title', 'Application Invitation Sent'),
      to: isThem ? `/application/create/${event?.listing_id}` : null,
      background: colors.green56,
      icon: EndTenancyRequestSentIcon
    },
    chat_id_verification_request: {
      title: isThem
        ? t('b.chat.view.id_verification_received.title', 'Request to Verify ID')
        : t('b.chat.view.id_verification_sent.title', 'ID Verification Request Sent'),
      to: isThem ? verificationLink : null,
      background: isThem ? colors.red64 : colors.green56,
      icon: IdVerification
    },
    chat_listing_verification_request: {
      title: isThem
        ? t('b.chat.view.listing_verification_received.title', 'Request to Verify Listing')
        : t('b.chat.view.listing_verification_sent.title', 'Listing Verification Request Sent'),
      to: isThem ? `${APP_PATH}/listing/verify/${event?.listing_id}` : null,
      background: isThem ? colors.red64 : colors.green56,
      icon: ListingVerification
    },
    chat_new_application: {
      title: isThem
        ? t('l.chat.view.application_received.title', 'Application Received')
        : t('r.chat.view.application_sent.title', 'Application Sent'),
      onClick: () =>
        window.open(
          `${APP_PATH}/chat/${event?.timeline_room}/application/${event?.reference_object_id}`,
          '_blank',
          'noopener,noreferrer'
        ),
      background: isThem ? colors.red64 : colors.green56,
      icon: isThem ? ApplicationReceivedIcon : DocumentSentIcon
    },
    chat_payment_request_approved: {
      title: isThem
        ? t('l.chat.view.rent_received.title', 'Payment Received')
        : t('r.chat.view.rent_sent.text', 'Payment Sent'),
      background: colors.green56,
      icon: isThem ? RentPaymentReceivedIcon : RentPaymentSentIcon,
      onClick: () => {
        return isTenant
          ? history.push(`/rental/${event.listing_id}/payments/${event.reference_object_id}`)
          : history.push(`/tenant/${event.listing_id}/payments/${event.reference_object_id}`)
      }
    },
    chat_payment_request_cancelled: {
      title: t('b.chat.view.payment_request_cancelled.title', 'Payment Request Cancelled'),
      background: colors.mediumGrey,
      icon: CancelledIcon
    },
    chat_payment_request_created: {
      title: isThem
        ? t('b.chat.view.payment_request_received.title', 'Payment Request Received')
        : t('b.chat.view.payment_request_sent.title', 'Payment Request Sent'),
      background: colors.green56,
      icon: isThem ? PaymentRequestReceivedIcon : RentPaymentSentIcon,
      onClick: e =>
        showPaymentDetailsModal({
          listingId: e?.listing_id,
          paymentId: e?.reference_object_id,
          history
        })
    },
    chat_user_signed_contract: {
      title: isThem
        ? t('l.chat.view.contract_signed_by.text', {
            defaultValue: 'Contract Signed by {{displayName}}',
            displayName
          })
        : t('b.chat.view.contract_signed.text', 'Contract Signed'),
      to: `/contract/${eventInfo.contract_id || event?.reference_object_id}`,
      background: colors.green56,
      icon: ContractSignedLandlordIcon
    },
    chat_contract_extension_started: {
      title: t('b.chat.view.contract_extension_started.title', 'New lease has taken effect'),
      background: colors.red64
    },
    listing_document_approval_accepted: {
      title: t('b.chat.view.proof_document_approved.title', 'Proof Document Approved'),
      to: `/listing/${eventInfo.listing_id}`,
      link: t('b.chat.view.view_listing.link', 'View listing'),
      background: colors.green56,
      icon: ProofDocumentApproved
    },
    listing_document_approval_declined: {
      title: t('b.chat.view.proof_document_not_approved.title', 'Proof Document Not Approved'),
      to: `/listing/verify/${eventInfo.listing_id}`,
      background: colors.red64,
      icon: ProofDocumentNotApproved
    },
    payment_method_pad: {
      title: t('b.chat.view.payment_method_pad.title', 'Pre-Authorized Debit Payments Added'),
      to: isTenant
        ? `/rental/${eventInfo.listing_id}/payments/${eventInfo.payment_request_id}/pre-authorized-debit`
        : `/tenant/${eventInfo.listing_id}/payments/${eventInfo.payment_request_id}/pre-authorized-debit`,
      background: colors.green56,
      icon: PadDocumentApproved
    },
    payment_method_other: {
      title: t('b.chat.view.payment_method_other.title', 'Pre-Authorized Debit Payments Stopped'),
      to: isTenant
        ? `/rental/${eventInfo.listing_id}/payments`
        : `/tenant/${eventInfo.listing_id}/payments`,
      background: colors.red64,
      icon: PadDocumentNotApproved
    },
    chat_payment_transaction_unresolved_underpaid: {
      title: t('b.chat.view.payment_incomplete.title', 'Payment Incomplete'),
      to: `/rental/${eventInfo.listing_id}/payments/${eventInfo.payment_id}`,
      background: colors.red64,
      icon: EndTenancyRequestRefusedIcon
    },
    pad_failed: {
      title: t(
        'b.chat.view.payment_method_pad_failed.title',
        'Pre-Authorized Debit Payments Failed'
      ),
      to: isTenant
        ? `/rental/${eventInfo.listing_id}/payments/${eventInfo.payment_request_id}/pre-authorized-debit`
        : `/tenant/${eventInfo.listing_id}/payments/${eventInfo.payment_request_id}/pre-authorized-debit`,
      background: colors.red64,
      icon: PadPaymentFailed
    },
    chat_custom_contracts_ready_review_sign: {
      title:
        (!isTenant && isThem) || (isTenant && !isThem)
          ? t('b.chat.view.document_received.title', 'Document Received')
          : t('b.chat.view.doument_sent.title', 'Document Sent'),
      onClick: () => getRoute(eventInfo),
      hideDefaultLinkText: true,
      background: (!isTenant && isThem) || (isTenant && !isThem) ? '#FB554B' : colors.lightGreen,
      icon: CustomContractIcon,
      description: eventInfo.document_name,
      status: getStatus(eventInfo)
    },
    chat_custom_contracts_void_all: {
      title: t('b.chat.view.douments_voided.title', 'All documents voided'),
      background: colors.grey48,
      icon: CustomContractVoidedIcon,
      hideDefaultLinkText: true,
      description: eventInfo.document_name
    },
    chat_custom_contracts_void_single: {
      title: t('b.chat.view.doument_voided.title', 'Document Voided'),
      background: colors.grey48,
      icon: CustomContractVoidedIcon
    },
    chat_custom_contracts_document_complete: {
      title: t('b.chat.view.agreement_completed.title', 'Agreement Completed!'),
      to: isTenant ? `/rental/${event.listing_id}` : `/contract/manager/${eventInfo.contract_id}`,
      hideDefaultLinkText: true,
      background: colors.lightGreen,
      icon: CustomContractCompleteIcon,
      description: eventInfo.document_name,
      status: {
        title: 'View Details',
        type: 'link'
      }
    },
    credit_check_failed: {
      title: t('r.credit_check_failed_chat_event_text', 'Credit Check Failed'),
      ...(isTenant ? { to: `/profile/trust-score` } : {}),
      background: colors.red64,
      icon: ApplicationReceivedIcon
    }
  }

  return data[event?.event_type]
}

export default metadata
